import React from "react";
import { Home } from "@mui/icons-material";
import { Divider, IconButton, InputBase, List, ListItem, ListItemButton, ListItemText, Paper, Popover, Stack, TextField, Typography } from "@mui/material";
import Service from "../../../../util/Service";
import SearchField from "../../../util/SearchField";


export default function EscolhePaginaComp(props) {
    const { action, pagina } = props;

    const [anchorEl, setAnchorEl] = React.useState(null);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [wait, setWait] = React.useState(true);
    const [paginas, setPaginas] = React.useState();
    const [paginasF, setPaginasF] = React.useState();

    const [projetos, setProjetos] = React.useState();
    const [projetosF, setProjetosF] = React.useState();

    const [kanbans, setKanbans] = React.useState();
    const [kanbansF, setKanbansF] = React.useState();

    React.useEffect(() => {
        if (open) {
            bustaTodasPaginas()
        }
    }, [open])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function bustaTodasPaginas() {

        Service.GET('/api/security/paginaHtml/findAllRestrito').then(r => {
            const f = r.filter(p => {
                if (p.tipo !== 'pagina') return false;
                if (!p.rules) return true;
                if (p.rules.includes("paginaPessoal")) return false;
                return true;
            })
            setPaginas(f);
            bustaTodosProjetos();
            setPaginasF(f);
        }).catch(e => {
            console.error(e);
        })
    }
    function bustaTodosProjetos() {
        Service.GET('/api/projeto/buscaTodosLimitado').then(r => {            
            setProjetos(r);
            setProjetosF(r);
            buscaTodosKanban();            
        }).catch(e => {
            console.error(e);
        })
    }
    function buscaTodosKanban(){
        Service.GET('/api/projeto/kanban/findAllLimitado').then(r => {
            
            setKanbans(r);
            setKanbansF(r);
            
            setWait(false);
        }).catch(e => {
            console.error(e);
        })
    }
    function formataData(time) {
        if (!time) return '';
        const dt = new Date(time);
        return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
    }

    function handleEscolhe(row) {
        if (action) action(row);
        handleClose();
    }
    function handleEscolheProjeto(row){
        if (action) action("/projeto/"+row.id);
        handleClose();
    }
    function handleEscolheKanban(row){
        if (action) action("/kanban/"+row.idProjeto+"/"+row.id);
        handleClose();
    }

    function handleFiltro(txt) {
        if (paginas){
            const arr = paginas.filter(p => {
                if (p.nome.toUpperCase().indexOf(txt.toUpperCase()) >= 0) return true;
                if (p.descricao && p.descricao.indexOf(txt) >= 0) return true;
                if (p.rules) {
                    const r = p.rules.filter(r => r.toUpperCase().indexOf(txt.toUpperCase()))
                    return r != null;
                }
                return false;
            });
            setPaginasF(arr);
        }
        if( projetos){
            const arr = projetos.filter(p => {
                if (p.nome.toUpperCase().indexOf(txt.toUpperCase()) >= 0) return true;
                if (p.descricao && p.descricao.indexOf(txt) >= 0) return true;
                if (p.rule) {
                    const r = p.rules.filter(r => r.toUpperCase().indexOf(txt.toUpperCase()))
                    return r != null;
                }
                return false;
            });
            setProjetosF(arr);
        }
        if( kanbans){
            const arr = kanbans.filter(p => {
                if (p.nome.toUpperCase().indexOf(txt.toUpperCase()) >= 0) return true;
                if (p.rule) {
                    const r = p.rules.filter(r => r.toUpperCase().indexOf(txt.toUpperCase()))
                    return r != null;
                }
                return false;
            });
            setKanbansF(arr);
        }
    }

    function handleChange(e) {
        let pg = {}
        if (pg == null || pg.nome == null) {
            pg = {
                nome: ''
            }
        };
        pg.nome = e.target.value;        
        if (action) action(pg);
    }

    function montaValor(){
        if( !pagina) return '';
        if( typeof pagina === 'string') return pagina;
        else return pagina.nome;
    }

    return (
        <Paper
            component="div"
            sx={{
                p: '2px 4px',
                display: 'flex',
                alignItems: 'center',
                width: 280
            }}
        >
            <InputBase
                sx={{ ml: 1, flex: 1 }}
                value={montaValor()}
                onChange={handleChange}
                
                placeholder="Area de trabalho"
                inputProps={{ 'aria-label': 'Filtro' }}
            />
            <IconButton sx={{ p: '10px' }} aria-label="show" onClick={handleClick}>
                <Home />
            </IconButton>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Stack>
                    <div style={{ padding: 10, background: 'lightGray' }}>
                        <SearchField width={300} handleSearch={handleFiltro} hotSearch={true} />
                    </div>
                    <List dense={true}
                        sx={{
                            width: 360, maxWidth: 360, bgcolor: 'background.paper',
                            overflow: 'auto',
                            maxHeight: 450,
                        }}
                    >
                        {wait &&
                            <ListItem
                                alignItems="flex-start"
                            >
                                <ListItemText sx={{ p: 2 }}>Aguarde...</ListItemText>
                            </ListItem>}
                        {!wait && paginasF && paginasF.map((row, id) =>
                            <ListItem
                                alignItems="flex-start" key={"list-popover-" + id}
                            >
                                {/* <ListItemButton onClick={() => handleEscolhe(row)}> */}
                                <ListItemText onClick={() => handleEscolhe(row)}
                                    sx={{ cursor: 'pointer' }}
                                    primary={<React.Fragment><b>Pagina: </b>{row.nome}</React.Fragment>}
                                    secondary={
                                        <React.Fragment>
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                sx={{ color: 'text.primary', display: 'inline' }}
                                            >
                                                {row.descricao}
                                            </Typography>
                                        </React.Fragment>
                                    }
                                />
                                {/* </ListItemButton> */}
                            </ListItem>
                        )}
                        {!wait && projetosF && <Divider />}
                        {!wait && projetosF && projetosF.map((row, id) =>
                            <ListItem
                                alignItems="flex-start" key={"list-popover-proj-" + id}
                            >
                                <ListItemText onClick={() => handleEscolheProjeto(row)}
                                    sx={{ cursor: 'pointer' }}
                                    primary={<React.Fragment><b>Projeto: </b>{row.nome}</React.Fragment>}
                                    secondary={
                                        <React.Fragment>
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                sx={{ color: 'text.primary', display: 'inline' }}
                                            >
                                                {row.descricao}
                                            </Typography>
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                        )}
                        {!wait && kanbansF && <Divider />}
                        {!wait && kanbansF && kanbansF.map((row, id) =>
                            <ListItem
                                alignItems="flex-start" key={"list-popover-proj-" + id}
                            >
                                <ListItemText onClick={() => handleEscolheKanban(row)}
                                    sx={{ cursor: 'pointer' }}
                                    primary={<React.Fragment><b>Kanban: </b>{row.nome}</React.Fragment>}
                                    secondary={
                                        <React.Fragment>
                                            <Typography
                                                component="span"
                                                variant="body2"
                                                sx={{ color: 'text.primary', display: 'inline' }}
                                            >
                                                {formataData(row.dtCriacao) }
                                            </Typography>
                                        </React.Fragment>
                                    }
                                />
                            </ListItem>
                        )}
                    </List>
                </Stack>
            </Popover>
        </Paper>
    )
}